import { render, staticRenderFns } from "./SpellingBeeLanding.vue?vue&type=template&id=52e34a3b&scoped=true"
import script from "./SpellingBeeLanding.js?vue&type=script&lang=js&external"
export * from "./SpellingBeeLanding.js?vue&type=script&lang=js&external"
import style0 from "./SpellingBeeLanding.scss?vue&type=style&index=0&id=52e34a3b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e34a3b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WfChip: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/WfChip.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
